import { ReactNode } from 'react'
import { Card, type DropdownItemObject } from '@jana-technology/platform-ui'

interface IGraphContainerCardProps {
  children: ReactNode
  title: string
  optionsComponent?: ReactNode
  actionMenuItems?: DropdownItemObject[]
}

/**
 * Card component to decorate each graph with title and options.
 *
 * @param title title to display at top left of card
 * @param optionsComponent component to show at top right of card
 * @param actionMenuItems items to display in the action menu (triple dot menu at top right of card)
 * @param children content to display within the card below header
 */
const GraphContainerCard = ({
  title,
  optionsComponent,
  actionMenuItems,
  children
}: IGraphContainerCardProps) => {
  return (
    <Card
      title={title}
      actions={optionsComponent ?? undefined}
      className='flex h-full flex-col [&_[data-slot="card-body"]]:flex-1 [&_[data-slot="card-body"]]:p-4'
      actionMenuItems={actionMenuItems}
      key={title}
    >
      {children}
    </Card>
  )
}

export default GraphContainerCard
